module.exports = __webpack_public_path__ + "img/will-guardianship.b8a45f5e.svg";